import BadgeIcon from 'components/BadgeIcon';

import { selectUnreadNotificationsCount } from 'features/notifications/notificationsSelectors';
import { setSidebarContent } from 'features/sidebar/sidebarSlice';

import { useAppDispatch, useAppSelector } from 'hooks/useTypedRedux';

import { SidebarContentTypes } from 'constants/enums';

import { ReactComponent as FiltersIcon } from 'assets/icons/filters.svg';
import { ReactComponent as NotificationsIcon } from 'assets/icons/notifications.svg';

import styles from './NotificationsIndicator.module.scss';

const NotificationsIndicator = () => {
  const unreadNotifications = useAppSelector(selectUnreadNotificationsCount);
  const isShowBadge = Boolean(unreadNotifications);
  const dispatch = useAppDispatch();

  const handleNotificationsViewOpen = () => {
    dispatch(
      setSidebarContent({ contentId: SidebarContentTypes.NotificationsView })
    );
  };

  return (
    <div className={styles.wrapper} onClick={handleNotificationsViewOpen}>
      <NotificationsIcon />

      <BadgeIcon
        showBadge={isShowBadge}
        icon={<FiltersIcon />}
        className={styles.badge}
      />
    </div>
  );
};

export default NotificationsIndicator;
